import api from "@/api/api"
import { query, mutation } from "../api/queries"
import dayjs from "dayjs"

export default {
	async readApps({ commit }, variables) {
		variables = { sort: { fieldName: "createdAt", type: "desc" } }
		const res = await api({ query: query.apps, variables })
		let apps = res?.data?.apps?.list ?? []
		// TODO: handle errors

		commit("putAppsList", apps)
		return Promise.resolve({ isSuccess: true, res })
	},

	async readApp({ commit, rootState }, { appId }) {
		commit("putAppDetail", {}) // reset
		const variables = { where: { appId } }
		const res = await api({ query: query.app, variables })
		let app = res?.data?.apps?.list?.[0] ?? null
		if (!app) return Promise.resolve({ isSuccess: false, res })

		// // Append computed fields
		const dateTimeFormat = rootState?.settings?.dateTimeFormat ?? "YYYY-MM-DD HH:MM"
		app = {
			...app,
			formattedCreatedAt: app.createdAt ? dayjs(app.createdAt).format(dateTimeFormat) : "",
			formattedLastModifiedAt: app.lastModifiedAt ? dayjs(app.lastModifiedAt).format(dateTimeFormat) : ""
		}

		commit("putAppDetail", app)
		return Promise.resolve({ isSuccess: true, res })
	},

	async createApp({ commit }, { appId, appName, host, regex }) {
		// 1: createApp with the URL in routing based on host + regex
		// 2: upsertCmsConfig - create a new config for this app
		const url = `${host ? host : ""}${regex ? regex : ""}`
		const input = { appId, appName, urlRouting: { regexPattern: url } }

		const resApp = await api({
			query: mutation.createApp,
			variables: { input }
		})

		// Handle errors
		if (resApp?.data?.createApp?.status !== "success") {
			return Promise.resolve({ isSuccess: false, res: resApp })
		}

		const resCmsConfig = await api({
			query: mutation.upsertCmsConfig,
			variables: { appId, config: {} }
		})
		// Handle errors
		if (resCmsConfig?.data?.upsertCmsConfig?.status !== "success") {
			return Promise.resolve({ isSuccess: false, res: resCmsConfig })
		}

		// All good
		commit("addAppToList", input)
		return Promise.resolve({ isSuccess: true })
	},

	async updateApp({ commit }, payload) {
		const { appId, appName, email, emailSenderName, urlRouting } = payload

		const res = await api({
			query: mutation.updateApp,
			variables: { appId, input: { appName, email, emailSenderName, urlRouting } }
		})

		// Handle errors
		if (res?.data?.updateApp?.status !== "success") {
			return Promise.resolve({ isSuccess: false, res })
		}

		// All good
		commit("putAppDetail", payload)
		return Promise.resolve({ isSuccess: true })
	},

	async deleteApp({ commit }, { appId }) {
		const res = await api({ query: mutation.deleteApp, variables: { appId } })
		console.log({ res })
		// TODO: handle errors
		if (res?.data?.deleteApp?.status !== "success") return Promise.resolve({ isSuccess: false, res })

		commit("removeAppFromList", appId)
		return Promise.resolve({ isSuccess: true, res })
	}
}
